/* oxlint-disable @typescript-eslint/no-explicit-any */
import { AboutMenu, Category, MenuType } from "@hermes/api-model-menu";

/**
 * Safe access to editorial data in menu entry
 */
export const getEdito = (entry: Category): any | undefined => {
    if (entry.type === MenuType.TYPE_PUSH) {
        const pushItem: any = {
            path: entry.path ?? "",
            title: entry.title ?? "",
            image: entry.image ?? "",
        };

        return pushItem;
    }
    return undefined;
};

/**
 * Utility function to clean the name of a MenuEntryItem from special characters.
 * It keeps only uppercase letters, numbers, and the "&" symbol.
 * This is specifically used for entries of type "story", which don't have a pimCode,
 * so we rely on the cleaned name to send consistent analytics data from the menu.
 */

export const getFormattedEntryName = (
    item: Category | AboutMenu,
): string | undefined => {
    let text: string | undefined;

    if ("label" in item) {
        text = item.label;
    } else if ("name" in item) {
        text = item.name;
    }

    if (text) {
        return text
            .toUpperCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036F]/g, "")
            .replace(/[^\p{L}\p{N}&]/gu, "");
    }

    return undefined;
};

export const isGridMenuEntry = (menuEntry: Category): boolean =>
    menuEntry.type === MenuType.TYPE_GRID;

export const isStoryMenuEntry = (menuEntry: Category): boolean =>
    menuEntry.type === MenuType.TYPE_STORY;

export const isOtherMenuEntry = (menuEntry: Category): boolean =>
    menuEntry.type === MenuType.TYPE_OTHER;

export const isMenuEntryWithSubCategories = (
    menuEntry: Category | undefined,
): boolean =>
    menuEntry?.subcategories !== undefined &&
    menuEntry.subcategories.length > 0;

export const isAboutMenuEntryWithSubItems = (
    menuEntry: AboutMenu | undefined,
): boolean => menuEntry?.items !== undefined && menuEntry.items.length > 0;

export const getCleanUrlPath = (fullPath: string): string => {
    if (!fullPath) {
        return "";
    }
    return fullPath.split(/[#?]/)[0];
};
